// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --txt-color: #757575;
    --main-color: #15243E;
    --white-color: #F5F7FB;
    --txt-color-low: #757575af;
    --font-size-med: 14px;
    --font-size-large: 18px;
    --font-size-small: 12px;
    --font-size-xSmall: 10px;
    --border-radios-small: 4px;
    --second-color: #1976D2;
    --forth-color: #27affd;
    --third-color: #0b2e6a;
    --border-table-color: #c1c1c1b0;
    --second-color-shadow: #1976d288;
    --hover-color: #dfdfdf85;
    --cancel-color: #ecf3f8;
    --error-color: #ff4646;
    --back-error-color: rgba(255, 211, 211, 0.64);
    --border-white-table-color: #ffffffb2;
    --green-low: #1fee08;
    --green-pastel: #229b14bf;
    --green: #229b14;
    --yellow-low: #ffee00;
    --yellow: #d4c600;
    --s1-low: #00ffdd;
    --s1: #008fe2;
    --red-alert: #c00000ce;
    --hover-blue-list: #80bdff;
    --tag-calendar-color: #61a9fc79;
}

.container {
    position: absolute;
    width: 85%;
    left: 15%;
    height: 93%;
    /* display: flex; */
    display: block;
    justify-content: center;
    flex-direction: row;
    background: var(--white-color);
    /* z-index: -2; */
}

.contMonitorMovil {
    position: absolute;
    width: 100%;
    /* left: 15%; */
    height: 100%;
    /* display: flex; */
    display: block;
    justify-content: center;
    flex-direction: row;
    background: var(--white-color);
}

.containerDark {
    position: absolute;
    width: 88%;
    left: 12%;
    height: 95%;
    /* display: flex; */
    display: block;
    justify-content: center;
    flex-direction: row;
    background: var(--main-color);
    /* z-index: -2; */
}

.MsgErrorGlobal {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    color: #c40303;
    font-size: larger;
}

.contMainError {
    position: relative;
    width: 40%;
    height: 80%;
    left: 30%;
    top: 10%;
    display: block;
}

.contTitleErrorMsg {
    position: relative;
    width: 100%;
    height: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #c40303;
    font-size: var(--font-size-large);

}

.contMainErrorMsg {
    position: relative;
    width: 100%;
    height: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: var(--main-color);
    font-size: var(--font-size-large);
}

.contMainErrorMsgDark {
    position: relative;
    width: 100%;
    height: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: var(--white-color);
    font-size: large;
}

.contDetailErrorMsg {
    position: relative;
    width: 100%;
    height: 70%;
    display: block
}

.RowInfoErrorMsg {
    position: relative;
    width: 100%;
    height: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.CellTxtErrorMsg {
    position: relative;
    width: 40%;
    height: 100%;
    display: flex;
    justify-content: start;
    align-items: center;
    text-align: center;
    color: var(--txt-color);
    font-size: var(--font-size-med);
}

.CellTxtErrorMsgDark {
    position: relative;
    width: 40%;
    height: 100%;
    display: flex;
    justify-content: start;
    align-items: center;
    text-align: center;
    color: var(--white-color);
    font-size: medium;
}

.CellValErrorMsg {
    position: relative;
    width: 20%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: aliceblue;
    font-size: var(--font-size-med);
}

/* **************************** horizontal Movil****************************** */
@media (min-width: 500px) and (max-width: 900px) {
    :root {
        --font-size-med: 10px;
        --font-size-large: 12px;
        --font-size-small: 8px;
        --font-size-xSmall: 6px;
    }

}

/* ****************************Movil****************************** */
@media (max-width: 500px) {
    :root {
        --font-size-med: 10px;
        --font-size-large: 12px;
        --font-size-small: 8px;
        --font-size-xSmall: 6px;
    }

    .container {
        width: 100%;
        left: 0%;
        top: 10%;
        height: 90%;
        overflow: auto;
    }

    .contMonitorMovil {
        position: absolute;
        width: 300%;
        /* left: 15%; */
        height: 100%;
        /* display: flex; */
        display: block;
        justify-content: center;
        flex-direction: row;
        background: var(--white-color);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/Container.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;IACtB,0BAA0B;IAC1B,qBAAqB;IACrB,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,+BAA+B;IAC/B,gCAAgC;IAChC,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,6CAA6C;IAC7C,qCAAqC;IACrC,oBAAoB;IACpB,yBAAyB;IACzB,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,SAAS;IACT,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,iCAAiC;;AAErC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;IACxB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA,gFAAgF;AAChF;IACI;QACI,qBAAqB;QACrB,uBAAuB;QACvB,sBAAsB;QACtB,uBAAuB;IAC3B;;AAEJ;;AAEA,oEAAoE;AACpE;IACI;QACI,qBAAqB;QACrB,uBAAuB;QACvB,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,QAAQ;QACR,QAAQ;QACR,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,eAAe;QACf,YAAY;QACZ,mBAAmB;QACnB,cAAc;QACd,uBAAuB;QACvB,mBAAmB;QACnB,8BAA8B;IAClC;AACJ","sourcesContent":[":root {\r\n    --txt-color: #757575;\r\n    --main-color: #15243E;\r\n    --white-color: #F5F7FB;\r\n    --txt-color-low: #757575af;\r\n    --font-size-med: 14px;\r\n    --font-size-large: 18px;\r\n    --font-size-small: 12px;\r\n    --font-size-xSmall: 10px;\r\n    --border-radios-small: 4px;\r\n    --second-color: #1976D2;\r\n    --forth-color: #27affd;\r\n    --third-color: #0b2e6a;\r\n    --border-table-color: #c1c1c1b0;\r\n    --second-color-shadow: #1976d288;\r\n    --hover-color: #dfdfdf85;\r\n    --cancel-color: #ecf3f8;\r\n    --error-color: #ff4646;\r\n    --back-error-color: rgba(255, 211, 211, 0.64);\r\n    --border-white-table-color: #ffffffb2;\r\n    --green-low: #1fee08;\r\n    --green-pastel: #229b14bf;\r\n    --green: #229b14;\r\n    --yellow-low: #ffee00;\r\n    --yellow: #d4c600;\r\n    --s1-low: #00ffdd;\r\n    --s1: #008fe2;\r\n    --red-alert: #c00000ce;\r\n    --hover-blue-list: #80bdff;\r\n    --tag-calendar-color: #61a9fc79;\r\n}\r\n\r\n.container {\r\n    position: absolute;\r\n    width: 85%;\r\n    left: 15%;\r\n    height: 93%;\r\n    /* display: flex; */\r\n    display: block;\r\n    justify-content: center;\r\n    flex-direction: row;\r\n    background: var(--white-color);\r\n    /* z-index: -2; */\r\n}\r\n\r\n.contMonitorMovil {\r\n    position: absolute;\r\n    width: 100%;\r\n    /* left: 15%; */\r\n    height: 100%;\r\n    /* display: flex; */\r\n    display: block;\r\n    justify-content: center;\r\n    flex-direction: row;\r\n    background: var(--white-color);\r\n}\r\n\r\n.containerDark {\r\n    position: absolute;\r\n    width: 88%;\r\n    left: 12%;\r\n    height: 95%;\r\n    /* display: flex; */\r\n    display: block;\r\n    justify-content: center;\r\n    flex-direction: row;\r\n    background: var(--main-color);\r\n    /* z-index: -2; */\r\n}\r\n\r\n.MsgErrorGlobal {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-content: center;\r\n    align-items: center;\r\n    color: #c40303;\r\n    font-size: larger;\r\n}\r\n\r\n.contMainError {\r\n    position: relative;\r\n    width: 40%;\r\n    height: 80%;\r\n    left: 30%;\r\n    top: 10%;\r\n    display: block;\r\n}\r\n\r\n.contTitleErrorMsg {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 20%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n    color: #c40303;\r\n    font-size: var(--font-size-large);\r\n\r\n}\r\n\r\n.contMainErrorMsg {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 10%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n    color: var(--main-color);\r\n    font-size: var(--font-size-large);\r\n}\r\n\r\n.contMainErrorMsgDark {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 10%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n    color: var(--white-color);\r\n    font-size: large;\r\n}\r\n\r\n.contDetailErrorMsg {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 70%;\r\n    display: block\r\n}\r\n\r\n.RowInfoErrorMsg {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 10%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.CellTxtErrorMsg {\r\n    position: relative;\r\n    width: 40%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: start;\r\n    align-items: center;\r\n    text-align: center;\r\n    color: var(--txt-color);\r\n    font-size: var(--font-size-med);\r\n}\r\n\r\n.CellTxtErrorMsgDark {\r\n    position: relative;\r\n    width: 40%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: start;\r\n    align-items: center;\r\n    text-align: center;\r\n    color: var(--white-color);\r\n    font-size: medium;\r\n}\r\n\r\n.CellValErrorMsg {\r\n    position: relative;\r\n    width: 20%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n    color: aliceblue;\r\n    font-size: var(--font-size-med);\r\n}\r\n\r\n/* **************************** horizontal Movil****************************** */\r\n@media (min-width: 500px) and (max-width: 900px) {\r\n    :root {\r\n        --font-size-med: 10px;\r\n        --font-size-large: 12px;\r\n        --font-size-small: 8px;\r\n        --font-size-xSmall: 6px;\r\n    }\r\n\r\n}\r\n\r\n/* ****************************Movil****************************** */\r\n@media (max-width: 500px) {\r\n    :root {\r\n        --font-size-med: 10px;\r\n        --font-size-large: 12px;\r\n        --font-size-small: 8px;\r\n        --font-size-xSmall: 6px;\r\n    }\r\n\r\n    .container {\r\n        width: 100%;\r\n        left: 0%;\r\n        top: 10%;\r\n        height: 90%;\r\n        overflow: auto;\r\n    }\r\n\r\n    .contMonitorMovil {\r\n        position: absolute;\r\n        width: 300%;\r\n        /* left: 15%; */\r\n        height: 100%;\r\n        /* display: flex; */\r\n        display: block;\r\n        justify-content: center;\r\n        flex-direction: row;\r\n        background: var(--white-color);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
